import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-lfsa-option-export-portal-compras',
  templateUrl: './lfsa-option-export-portal-compras.component.html',
  styleUrls: ['./lfsa-option-export-portal-compras.component.css']
})
export class LfsaOptionExportPortalComprasComponent implements OnInit {

  @Output() devolverAccionExportPortal = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {}

  exportarAnual() {
    this.devolverAccionExportPortal.emit('anual');
  }

  exportarMensual() {
    this.devolverAccionExportPortal.emit('mensual');
  }
}
